/* eslint-disable */

export enum NetworkType {
  BLUETOOTH = "BLUETOOTH",
  WIFI = "WIFI",
  CELLULAR = "CELLULAR",
}

export interface Network {
  carrier?: string;
  network_type?: NetworkType;
  ip_address?: string;
}
